import { render, staticRenderFns } from "./TransactionFlowPendingDetail.vue?vue&type=template&id=ac52be2a&scoped=true&"
import script from "./TransactionFlowPendingDetail.vue?vue&type=script&lang=js&"
export * from "./TransactionFlowPendingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac52be2a",
  null
  
)

export default component.exports